import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true }); // admin session = httpOnly cookie

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};

export const IMG_WIDTHS = [320, 480, 640, 960, 1280, 1920];

// Resized WebP variant of a stored image. Only our own /api/files URLs are transformable.
export const imgUrl = (src, w) => {
  if (!src || !src.includes("/api/files/") || src.includes("/api/files/preview/")) return src;
  return `${src}${src.includes("?") ? "&" : "?"}w=${w}&fmt=webp`;
};

export const imgSrcSet = (src, widths = IMG_WIDTHS) => {
  if (!src || !src.includes("/api/files/") || src.includes("/api/files/preview/")) return undefined;
  return widths.map(w => `${imgUrl(src, w)} ${w}w`).join(", ");
};

export const formatUSD = (n) => {
  const v = Number(n) || 0;
  // Show cents unless the amount is a whole dollar
  const hasCents = Math.round(v * 100) % 100 !== 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(v);
};
